import { useMemo, useState } from 'react';
import { AccessSessionClientModel, AccessSessionsGroupClientModel } from '@apono/client-app-sdk';

import { LoadMoreAccessSessions } from '@MyAccess/organisms/LoadMoreAccessSessions';
import AccessSessionGroupWrapper from '@MyAccess/components/AccessSessionGroupWrapper';
import { getGroupIcons } from '@MyAccess/utils/helpers';

import AccessSession from './AccessSession';

export default function AccessSessionGroup({ group }: { group: AccessSessionsGroupClientModel }) {
  const [loadedSessions, setLoadedSessions] = useState<AccessSessionClientModel[]>([]);

  const allSessions = useMemo(() => [...group.sessions, ...loadedSessions], [group.sessions, loadedSessions]);

  return (
    <AccessSessionGroupWrapper
      key={group.integration?.id}
      {...{
        total: group.total,
        groupIcons: getGroupIcons(group),
        groupName: group.integration?.name,
        groupIcon: group.integration?.icons.svg,
      }}
    >
      <>
        {allSessions.map((session) => (
          <AccessSession key={session.id} session={session} />
        ))}
        {group.total > allSessions.length && group.integration?.id && (
          <LoadMoreAccessSessions
            integrationId={group.integration?.id}
            initOffset={group.sessions.length}
            onLoadSessions={setLoadedSessions}
          />
        )}
      </>
    </AccessSessionGroupWrapper>
  );
}
